import { render, staticRenderFns } from "./TicketGrabberStation.vue?vue&type=template&id=35049de4&scoped=true&"
import script from "./TicketGrabberStation.vue?vue&type=script&lang=js&"
export * from "./TicketGrabberStation.vue?vue&type=script&lang=js&"
import style0 from "./TicketGrabberStation.vue?vue&type=style&index=0&id=35049de4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35049de4",
  null
  
)

export default component.exports